<div class="d-flex mt-5 pt-5 flex-column">
  <h1 class="font-weight-bolder text-success text-center">Web page under construction.</h1>
  <h3 class="font-weight-bold text-primary text-center">Coming soon.</h3>
</div>